module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Location_16"],"path":[{"$":{"d":"M8,0A6,6,0,0,0,2,5.9C2,9,7.39,15.3,7.62,15.56L8,16l.38-.44C8.61,15.3,14,9,14,5.9A6,6,0,0,0,8,0ZM8,9a3,3,0,1,1,3-3A3,3,0,0,1,8,9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Location1_16.svg
// module id = o/HB
// module chunks = 1